"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var SignaturePopup_1 = require("./SignaturePopup");
var test_json_data_1 = require("./test_json_data");
var stringifyDate = __importStar(require("json-stringify-date"));
new SignaturePopup_1.SignaturePopup();
var submit_button = document.getElementById("submit_form_button");
if (submit_button) {
    submit_button.addEventListener("click", submit);
}
if (process.env.DEBUG === "true") {
    window.pdf.json_data = test_json_data_1.test_json_data;
}
var secondary_json_data = {
    slug: "anho",
    campus: "West Palm Beach",
    pack_id: "anho_application",
    start_date: "2020-06-30",
    advisor_email: "jorge@klassapp.com",
    forms: [
        {
            url: process.env.BASE_DOMAIN + "?form_id=application",
            title: "Application"
        },
        {
            url: process.env.BASE_DOMAIN + "?form_id=signature_certificate",
            title: "Signature Certificate"
        }
    ]
};
function submit() {
    return __awaiter(this, void 0, void 0, function () {
        var taskUserId, token, pdf, _a, post_main_form, check, url, _b, status_1, body, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    taskUserId = window.taskUserId, token = window.token, pdf = window.pdf, _a = window.post_main_form, post_main_form = _a === void 0 ? "" : _a;
                    return [4, pdf.validate()];
                case 1:
                    check = _c.sent();
                    if (!check) {
                        alert("Please check errors");
                        return [2];
                    }
                    pdf.setLoading(true);
                    url = "/answer/" + taskUserId;
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, , 5]);
                    return [4, sendRequest(pdf.json_data, url, token)];
                case 3:
                    _b = _c.sent(), status_1 = _b.status, body = _b.body;
                    pdf.setLoading(false);
                    if (status_1 !== 200) {
                        return [2];
                    }
                    showSuccessPage(body._id);
                    return [3, 5];
                case 4:
                    error_1 = _c.sent();
                    console.log(error_1);
                    return [3, 5];
                case 5: return [2];
            }
        });
    });
}
function reject(reason) {
    return __awaiter(this, void 0, void 0, function () {
        var taskUserId, token, pdf, status;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    taskUserId = window.taskUserId, token = window.token, pdf = window.pdf;
                    pdf.setLoading(true);
                    return [4, sendRequest({ taskUserId: taskUserId, reason: reason }, "/reject", token)];
                case 1:
                    status = (_a.sent()).status;
                    pdf.setLoading(false);
                    if (status !== 200) {
                        return [2];
                    }
                    showRejectedPage();
                    return [2];
            }
        });
    });
}
window.reject = reject;
function sendRequest(json_data, url, token) {
    return __awaiter(this, void 0, void 0, function () {
        var rawResponse, body, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch("" + process.env.TASKS_API + url, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            auth_token: "Bearer " + token
                        },
                        body: stringifyDate.stringify(json_data)
                    })];
                case 1:
                    rawResponse = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, rawResponse.json()];
                case 3:
                    body = _a.sent();
                    return [3, 5];
                case 4:
                    e_1 = _a.sent();
                    body = {};
                    return [3, 5];
                case 5: return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function showSuccessPage(id) {
    return __awaiter(this, void 0, void 0, function () {
        var completedUrl;
        return __generator(this, function (_a) {
            completedUrl = window.completedUrl;
            window.top.location.href = completedUrl;
            return [2];
        });
    });
}
function showRejectedPage() {
    return __awaiter(this, void 0, void 0, function () {
        var rejectedUrl;
        return __generator(this, function (_a) {
            rejectedUrl = window.rejectedUrl;
            window.top.location.href = rejectedUrl;
            return [2];
        });
    });
}
function waitUntilJobComplete(id) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve, reject) {
                    var interval_id = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                        var status, body, r, e_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4, sendRequest({}, "/check/" + id)];
                                case 1:
                                    r = _a.sent();
                                    status = r.status;
                                    body = r.body;
                                    return [3, 3];
                                case 2:
                                    e_2 = _a.sent();
                                    clearInterval(interval_id);
                                    clearTimeout(timeout_id);
                                    reject(e_2);
                                    return [2];
                                case 3:
                                    console.log(body.jobs);
                                    if (status !== 200) {
                                        clearInterval(interval_id);
                                        clearTimeout(timeout_id);
                                        reject("Got status code not 200 from API");
                                    }
                                    if (body.jobs.status === "done") {
                                        clearInterval(interval_id);
                                        clearTimeout(timeout_id);
                                        resolve();
                                    }
                                    return [2];
                            }
                        });
                    }); }, 3000);
                    var timeout_id = setTimeout(function () {
                        clearInterval(interval_id);
                        reject(new Error("1 minute timeout reached"));
                    }, 60 * 1000);
                })];
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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